// extracted by css-extract-rspack-plugin
var _1 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__dashNew-ywnnld";
var _2 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__isVisible-wSALKM";
var _3 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__loaderWrapper-rs1WIt";
var _4 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__preloaderCircular-WXzRkj";
var _5 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__preloaderPathNew-aP71mz";
var _6 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__rotate-KnkUwK";
var _7 = "src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__youSpinMeRound-FmWEeO";
export { _1 as "dashNew", _2 as "isVisible", _3 as "loaderWrapper", _4 as "preloaderCircular", _5 as "preloaderPathNew", _6 as "rotate", _7 as "youSpinMeRound" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"dashNew\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__dashNew-ywnnld\",\"isVisible\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__isVisible-wSALKM\",\"loaderWrapper\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__loaderWrapper-rs1WIt\",\"preloaderCircular\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__preloaderCircular-WXzRkj\",\"preloaderPathNew\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__preloaderPathNew-aP71mz\",\"rotate\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__rotate-KnkUwK\",\"youSpinMeRound\":\"src-components-RightBar-MessageList-MessageLoader-MessageLoader-module__youSpinMeRound-FmWEeO\"}";
        // 1752373455130
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  